<h1 class="mat-headline-6">{{ data.header }}</h1>
<div mat-dialog-content>
  <div class="row">
    <span class="col-sm-2 item-label"
      >{{ 'ACCOUNT.SERVICE' | translate }}:</span
    >
    <span class="col-sm-10 mb-1">{{ data.booking.service_name }}</span>

    <span class="col-sm-2 item-label">{{ 'ACCOUNT.DATE' | translate }}:</span>
    <span class="col-sm-10 mb-1">{{
      data.booking.datetime.format('Do MMMM YYYY')
    }}</span>

    <span class="col-sm-2 item-label">{{ 'ACCOUNT.TIME' | translate }}:</span>
    <span class="col-sm-10 mb-1">{{
      data.booking.datetime | date : 'HH:mm'
    }}</span>

    <span class="col-sm-2 item-label"
      >{{ 'ACCOUNT.LOCATION' | translate }}:</span
    >
    <span class="col-sm-10 mb-1">{{ data.location.name }}</span>
  </div>
  <hr />

  <div *ngIf="data.action === 'cancel'" class="cancel-messages">
    <p *ngIf="cancelMessage">{{ 'ACCOUNT.CANCEL_MESSAGE' | translate }}</p>
    <p *ngIf="cancelPromptMessage">{{ 'ACCOUNT.CANCEL_PROMPT' | translate }}</p>
    <p *ngIf="cancelPassed">{{ 'ACCOUNT.CANCEL_PERIOD_PASSED' | translate }}</p>
  </div>

  <div *ngIf="data.action === 'modify'">
    <app-mat-calendar
      [service]="data.service"
      [location]="data.location"
      (selectSlotUpdate)="selectedSlotCheck($event)"
      class="row"
    >
    </app-mat-calendar>

    <hr />

    <div class="mt-1">
      <p *ngIf="slotEmpty" class="slotEmpty">
        {{ 'ACCOUNT.SLOT_EMPTY' | translate }}
      </p>
      <p *ngIf="selectedSlot" class="selectedMessage">
        You have chosen to reschedule to the following date and time:
        {{ selectedSlot | date : 'd MMMM y, HH:mm' }}
      </p>
    </div>
  </div>

  <div *ngIf="data.action === 'details'">
    <div
      *ngFor="let question of data.booking.questions | keyvalue"
      class="row mb-3"
    >
      <label class="col-sm-4">{{ question.value.name }}</label>
      <input
        type="text"
        [disabled]="true"
        value="{{ question.value.answer }}"
        class="col-sm-8"
      />
    </div>
  </div>
  <div mat-dialog-actions class="row">
    <div class="col-sm-6">
      <button mat-button (click)="onNoClick()" class="btn btn-primary">
        Close
      </button>
    </div>
    <div class="col-sm-6 text-right" *ngIf="data.action === 'cancel'">
      <button
        mat-button
        class="btn btn-primary"
        (click)="continue()"
        *ngIf="cancelMessage"
        [disabled]="cancelPassed"
      >
        {{ 'ACCOUNT.CONTINUE' | translate }}
      </button>
      <button
        mat-button
        class="btn btn-primary cancel-btn"
        (click)="cancelBooking(data.member, data.booking)"
        *ngIf="cancelPromptMessage"
      >
        {{ 'ACCOUNT.CANCEL' | translate }}
      </button>
    </div>

    <div class="col-sm-6 text-right" *ngIf="data.action === 'modify'">
      <button
        mat-button
        class="btn btn-primary"
        (click)="confirmAmend(data.booking, selectedSlot, data.member)"
      >
        {{ 'ACCOUNT.RESCHEDULE_BOOKING' | translate }}
      </button>
    </div>
  </div>
</div>
